import {Routes, Route} from 'react-router-dom';
import {UserReferralPartnerOverview} from './overview/UserReferralPartnerOverview';
import {UserReferralPartnerDashboard} from './UserPartnerDashboard/UserPartnerDashboard';
import {UserPartnerReferrals} from './referrals/UserPartnerReferrals';
import {ReferralPartnerEarnings} from './earnings/ReferralPartnerEarnings';

export const UserReferralPartner = () => {
  return (
    <Routes>
      <Route path="/" element={<UserReferralPartnerDashboard />}>
        <Route index element={<UserReferralPartnerOverview />} />
        <Route path="referrals" element={<UserPartnerReferrals />} />
        <Route path="earnings" element={<ReferralPartnerEarnings />} />
      </Route>
    </Routes>
  );
};
